// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { MessageProcessorBase } from './MessageProcessorBase';
import { PFixOTTResponseMessage } from '../Messages/PFixOTTResponseMessage';
import { OTTResponseMessage } from '@shared/utils/DirectMessages/ExternalLink/OTTResponseMessage';
export class OTTResponseMessageProcessor extends MessageProcessorBase {
    decode(fieldSet) {
        const pfixMsg = new PFixOTTResponseMessage(fieldSet);
        const msg = new OTTResponseMessage();
        msg.externalId = pfixMsg.getExternalId();
        msg.oneTimeToken = pfixMsg.getOneTimeToken();
        return [msg];
    }
}
